import I18n from 'i18n-js'

import normalizeLocaleName from '@src/lib/normalizeLocaleName'

import en from '../i18n/langs/en.json'

I18n.fallbacks = true
I18n.defaultLocale = 'en'
I18n.locale = normalizeLocaleName('en')
I18n.translations = {
  en,
}

const origMissingTranslation = I18n.missingTranslation.bind(I18n)

export const finishSetup = (locale?: string) => {
  const searchParams = new URLSearchParams(window.location.search)
  I18n.locale = normalizeLocaleName(
    searchParams.get('enrollment_page_language_override') ||
      locale ||
      localStorage.getItem('language') ||
      navigator.language,
  )
  // Now that we've been told the app is ready to go, we can go back to using
  // fallbacks and use the standard "missing translation" message, rather than
  // crash the app when a developer is using a translation that hasn't been
  // defined yet.
  I18n.fallbacks = true
  I18n.missingTranslation = origMissingTranslation
}

// When developing, we want to let developers know that they're using the I18n
// system in a way that will not work.
if (process.env.NODE_ENV !== 'production') {
  I18n.fallbacks = false
  I18n.missingTranslation = (scope) => {
    throw new Error(`I18n requested for ${scope} before i18n was set up`)
  }
}
